import {h, Component} from 'preact';

class TypingIndicatorChatBody extends Component {
    render()
    {
        return (
            <div class='typing-indicator-chat-body-wrapper'>
                <div class='typing-indicator-chat-body'>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
            </div>
        );
    }
}



export default TypingIndicatorChatBody;



// WEBPACK FOOTER //
// ./routes/Chat/Chat/TypingIndicatorChatBody.js